import moment from "moment";
import _ from "lodash";
import Tag, { TagColor } from "@bedrock/components/lib/Tag";
import React, { ReactNode } from "react";
import { isBlank } from "@bedrock/utils";
import { jsonLogicStrToBool } from "#utils/index";
import { defs } from '#services';
import { $sType } from '#utils/index';

export const openIframe = (url) => {
  window.open(url, '_blank');
}

// 计算耗时  传timestamp时间戳
export const calculateTimeConsuming = (timestamp: string | number) => {
  if (!timestamp) return '0分钟'
  const duration = moment.duration(timestamp);
  // 计算总天数
  const totalDays = Math.floor(duration.asDays());
  // 获取、时、分、秒
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  // ${seconds ? seconds + '秒' : ''}
  const value = `${totalDays ? totalDays + '天' : ''}${hours ? hours + '小时' : ''}${minutes ? minutes + '分钟' : ''}`
  return value || '0分钟'
}

export enum ScoreType {
  // 综合评分
  overallScore = 'overallScore',
  // 历史评分
  historyScore = 'historyScore'
}


export const SCORETIP = '按照过程评分占比35%，结果评分占比65%计算得出'

export const ScoreTextMap = {
  [ScoreType.overallScore]: {
    title: '近期综合评分',
    tip: '一年内最近20个综合评分有值的需求单平均分',
  },
  [ScoreType.historyScore]: {
    title: '历史综合评分',
    tip: '所有综合评分有值的需求单平均分',
  }
}


/**
 * 获取超时配置
 * @param param0 { delay_grade,  delay_label, tagCompMarginLeft, tagCompColorLight }
 * @returns 
 */
export const getOvertimeConf = ({ delay_grade,  delay_label, tagCompMarginLeft = '0.5rem', tagCompColorLight = false }): { 
  panelHeaderbgClassName: string, tagColor: TagColor, text: string, tagComp?: ReactNode 
} => {
  const conf: Record<string, { panelHeaderbgClassName: string, tagColor: TagColor, text?: string }> = {
    // no_overtime: { panelHeaderbgClassName: 'panel_header_bg_green', tagColor: 'green', text: '未超时' },
    // overtime_48: { panelHeaderbgClassName: 'panel_header_bg_orange', tagColor: 'orange', text: '已超48小时' },
    // overtime_120 : { panelHeaderbgClassName: 'panel_header_bg_red', tagColor: 'red', text: '已超时120小时' },
    '0': { panelHeaderbgClassName: 'panel_header_bg_green', tagColor: 'green' },
    '1': { panelHeaderbgClassName: 'panel_header_bg_orange', tagColor: 'orange' },
    '2' : { panelHeaderbgClassName: 'panel_header_bg_red', tagColor: 'red' },
  };

  const currConf = conf[delay_grade];
  
  return {
    ...currConf,
    text: delay_label,
    tagComp: !currConf ? null :
      <Tag 
        style={{ marginLeft: tagCompMarginLeft }} 
        color={`${tagCompColorLight ? 'light-' : ''}${currConf.tagColor}` as TagColor} 
        text={delay_label}
        size="xSmall"
      />,
  }
}

/** 空值 to default -- */
export const emptyValueToDefault = (value) => {
  if (value === null || value === undefined) {
    return '--';
  };
  return value;
}

/**
 * 格式化true-是，false-否展示
 * @param val
 * @returns
 */
export const formatTruefalseDisplay = (val?: boolean) => {
  if (val === undefined) return '--';
  return val ? '是' : '否';
};

export const defaultTableCellRender = (v: any, r: any, i: number) => {
  if (isBlank(v)) return '--';
  if (typeof v === 'boolean') return formatTruefalseDisplay(v);
  if (typeof v === 'object') return JSON.stringify(v);
  return v;
}

// 处理row的key，如果key有l1$的前缀，则去掉这个前缀
export const handleRowData = (row: any) => {
  if (!row) return {};
  const newRow = {};
  Object.keys(row).forEach((key) => {
    if (key.startsWith('l1$DCP')) {
      newRow[key.replace('l1$', '')] = row[key];
    } else {
      newRow[key] = row[key];
    }
  });
  return newRow;
}

const getFinalRequiredMode = (column: defs.DemandQuoteTableColumnDto, row: any) => {
  const { required_mode, required_condition } = column;
  if (required_mode === 2) {
    return jsonLogicStrToBool(required_condition?.express, handleRowData(row)) ? 1 : required_condition?.fallback;
  }
  return required_mode;
}

// 处理必填规则
export const getRequiredRule = (
  column: defs.DemandQuoteTableColumnDto,
  row: any,
) => {
  const { required_mode, required_condition, data_type } = column;
  let rule = [];
  const finalRequiredMode = getFinalRequiredMode(column,  row);
  if (data_type === 'text_with_upload') {
    const requiredRule = {
      validator: (rule, value, callback) => {
        if (!value?.text && !value?.files?.length) {
          callback('此项必填');
          return;
        }
        callback();
      },
    }
    const noFillRule = {
      validator: (rule, value, callback) => {
        if (value?.text || value?.files?.length) {
          callback('此项不可填');
          return;
        }
        callback();
      },
    }
    if (finalRequiredMode === 1) {
      rule.push(requiredRule);
    }
    if (finalRequiredMode === 3) {
      rule.push(noFillRule);
    }
    return rule;
  }
  if (required_mode === 1) {
    rule.push({
      required: true,
      message: '此项必填',
    });
  }
  if (required_mode === 2) {
    // 如果data的key有l1$的前缀，则去掉这个前缀
    let required = jsonLogicStrToBool(required_condition?.express, handleRowData(row))
      ? true
      : required_condition?.fallback;
    if (required === true) {
      rule.push({
        required: true,
        message: '此项必填',
      });
    }
    if (required === 3) {
      rule.push({
        validator: (rule, value, callback) => {
          // 此项不可填，判断如果是数组，则toString为空，否则判断是否为空
          let str = value;
          if (Array.isArray(value)) {
            str = value.toString();
          }
          if (!str && str !== 0) {
            callback();
          } else {
            callback('此项不可填');
          }
        },
      });
    }
  }
  return rule;
};

// getConditionDisabled
export const getConditionDisabled = (
  column: defs.DemandQuoteTableColumnDto,
  row: any,
) => {
  const { required_mode, required_condition } = column;
  if (required_mode === 2) {
    let required = jsonLogicStrToBool(required_condition?.express, handleRowData(row))
      ? true
      : required_condition?.fallback;
    return required === 3;
  }
  return false;
};

// 处理必填枚举
export const getOptionsRule = (options: { name: string; value: string }[]) => {
  if (!Array.isArray(options)) {
    return [];
  }
  return [
    {
      validator: (rule, value, callback) => {
        if (!value || !value?.toString()) {
          callback();
          return;
        }
        // value可能是数组或者字符串，需要分别判断
        if (Array.isArray(value)) {
          if (value.every((n) => options?.some?.((m) => m.value === n))) {
            callback();
          } else {
            callback('选项不匹配');
          }
        } else if (options.some((n) => n.value === value)) {
          callback();
        } else {
          callback('选项不匹配');
        }
      },
    },
  ];
};


// 处理选项配置
export const getLogicOptions = (header: defs.DemandQuoteTableColumnDto, row?: any | 'all') => {
  const { code, options } = header;

  // 特别处理标品的选项
  if (code?.match?.(/^standardCode/)) {
    const sLevel = +code.replace(/^standardCode/, '');
    const parentCode = `standardCode${sLevel - 1}`;
    let options: any[] =
      header.standards?.filter((n) => n.level === sLevel) || [];
    if (sLevel > 1) {
      options = options.filter(
        (n) => n.parent_code === row?.[parentCode]?.toString()
      );
    }
    options =
      options?.map?.((n) => {
        return {
          value: n.code,
          name: n.name,
          short_code: n.short_code,
          id: n.id,
        };
      }) || [];
    return options;
  }

  if (row === 'all' && options?.use_condition) {
    let result = options?.groups?.reduce((acc, group) => {
      group.options?.forEach((n) => {
        acc.add(n);
      });
      return acc;
    }, new Set());
    return Array.from(result).map((n) => ({
      name: n,
      value: n,
    }));
  }

  if (options?.use_condition && row) {
    let result = [];
    for (const group of options?.groups || []) {
      if (jsonLogicStrToBool(group.express, handleRowData(row))) {
        result = group.options;
        break;
      }
    }
    return result.map((n) => ({
      name: n,
      value: n,
    }));
  }
  if (!options?.options) {
    return [];
  }
  return options.options.map((n) => ({
    name: n,
    value: n,
  }));
};

/** 获取内包结构化版本，一级单拆单、二级单退回到策划拆单 */
export const getInnerStructuredSersion = (detail, view) => {
  const inner_structured_version = detail?.structured_version === 0 && !view ?
    // 一级单拆单 或 二级单退回到策划拆单 时，结构化版本为1
    detail?.depth === 0 || detail?.state === "pending_design" ? 1 : 0 
    :
    detail?.structured_version;

  return inner_structured_version;
}